import { Injectable } from '@angular/core';
import { AuditQuery } from 'app/models/report/audit-query';
import { Observable } from 'rxjs';
import { AuditLog } from 'app/models/report/audit-log';
import { environment } from 'environments/environment';
import { UtilityService } from 'app/services/utility.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class AuditReportService {
	constructor(private readonly utilityService: UtilityService, private readonly httpClient: HttpClient) {}

	getAuditReport(auditQuery: AuditQuery): Observable<AuditLog[]> {
		return this.httpClient
			.get<AuditLog[]>(`${environment.apiUrl}audit-report?${this.utilityService.objectToQueryString(auditQuery)}`)
			.pipe();
	}

	getAuditReportByFormId(formId: string): Observable<AuditLog[]> {
		return this.httpClient.get<AuditLog[]>(`${environment.apiUrl}audit-report/${formId}`).pipe();
	}

	getChangeHistorySummary(clientId: string, formId: string): Observable<string | null> {
		const url = `${environment.apiUrl}audit-report/clients/${clientId}/forms/${formId}/change-history-summary`;
		return this.httpClient.get<string | null>(url, { responseType: 'text' as 'json' });
	}
}
